module.exports = __webpack_public_path__ + "static/media/activity-sample.1963a3b0.jpg";